import PropTypes from "prop-types"
import { Text, Title } from "ui/Typography"
import styles from "./PageTitle.module.css"
import classNames from "classnames"

export const PageTitle = ({ title, subTitle }) => {
  const hasContent = title || subTitle

  return (
    <div className={classNames(styles.wrapper, { "p-0": !hasContent })}>
      {title && (
        <Title level={3} className="mb-0">
          {title}
        </Title>
      )}
      {subTitle && (
        <Text variant="sub" size="lg">
          {subTitle}
        </Text>
      )}
    </div>
  )
}

PageTitle.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string
}
